import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, DialogProps, Typography } from '@mui/material';
import Close from '@mui/icons-material/Close';
interface ResponsiveDialogProps {
  title: string;
  subTitle:string;
  customWidth?:number;
  setOpenDialog: any;
  customMaxWidth?:any;
  openDialog: boolean;
  children: React.ReactNode;
}

const ResponsiveDialog = ({ title,customMaxWidth, customWidth,subTitle, openDialog, setOpenDialog, children }: ResponsiveDialogProps) => {

  const [maxWidth ,setMaxWidth] = React.useState<DialogProps['maxWidth']>( 'xl' );

  React.useEffect(()=>{
   if(customMaxWidth) setMaxWidth(customMaxWidth)
  },[customMaxWidth])
  return (
    <Dialog
      open={openDialog}
      maxWidth={maxWidth}
      onClose={() => setOpenDialog('')}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h5">
          {title}
        </Typography>
        <Typography variant="h5">
          {subTitle}
        </Typography>
        <IconButton onClick={() => setOpenDialog('')}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{width:customWidth}}>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default ResponsiveDialog;